import { cn } from '@goaltree/ui/lib/utils'

export function BrandMark({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        'flex size-[26px] shrink-0 items-center justify-center rounded-[8px] bg-primary/14 text-primary-text',
        className,
      )}
    >
      <svg viewBox="22 14 52 70" className="size-4" aria-hidden="true">
        <path
          d="M40 16C44 30 54 36 56 50C60 42 59 34 57 28C66 36 70 46 70 58C70 72 60 82 48 82C36 82 26 72 26 59C26 44 38 36 40 16ZM48 54C52 60 56.5 63 56.5 69C56.5 74 52.5 78 48 78C43.5 78 39.5 74 39.5 69C39.5 63 44 60 48 54Z"
          fill="currentColor"
          fillRule="evenodd"
        />
      </svg>
    </span>
  )
}
